var DAYS_NAMES = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
var DAYS_VALUES = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
(function () {
    'use strict';

    function WeeklyWorkDaysV2Controller($scope, $state, translate, translatePartialLoader, $mdDialog) {
        var $ctrl = this;

        $ctrl.checkedDays = checkAllAsDefault();
        $ctrl.checkedDays = getCheckedDays();
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.allWeekDays = getAllWeekDays();
        //console.log('checked days :')
        //console.log($ctrl.checkedDays);
        //console.log('all week days :')
        //console.log($ctrl.allWeekDays);
        var defaultStartTime = new Date();
        var defaultEndTime = new Date();
        var inited = false;


        //
        $scope.$watch('$ctrl.selectedWeeklyScheduleInfo', function () {
            //   console.log($ctrl.selectedWeeklyScheduleInfo);
            //       if($ctrl.selectedWeeklyScheduleInfo.weekdays!=undefined) {
            $scope.$watch('$ctrl.selectedWeeklyScheduleInfo.weekdays', function () {
                if ($ctrl.selectedWeeklyScheduleInfo && $ctrl.selectedWeeklyScheduleInfo.weekdays) {

                    if (!inited) {
                        inited = true;
                        $ctrl.checkedDays = getCheckedDays();
                        $ctrl.allWeekDays = getAllWeekDays();
                    }
                }

            }, true);


            //     }


        }, true);

        function onCheckChanged() {
            setCheckedDays();
        }

        function checkAllAsDefault() {
            var retChekDays = [];
            //angular.forEach(DAYS_VALUES, function (val) {
            //    retChekDays.push(val);
            //});
            return retChekDays;
        }

        function getCheckedDays() {


            if ($ctrl.selectedWeeklyScheduleInfo != undefined && $ctrl.selectedWeeklyScheduleInfo.weekdays != undefined) {
                var weekDays = $ctrl.selectedWeeklyScheduleInfo.weekdays;
                if (weekDays.length > 0) {
                    var retChekDays = [];
                    angular.forEach(weekDays, function (val) {
                        retChekDays.push(val.weekday);
                    });
                    return retChekDays;

                }
            }
            return $ctrl.checkedDays;
        }

        function setCheckedDays() {

            $ctrl.selectedWeeklyScheduleInfo.weekdays = [];
            angular.forEach($ctrl.allWeekDays, function (val) {
                if (val.checked) {

                    $ctrl.selectedWeeklyScheduleInfo.weekdays.push({weekday: val.value, timePeriod: val.timePeriod});
                }
            });


        }

        function getAllWeekDays() {
            var retList = [];

            for (var i = 0; i < 7; i++) {
                var tp = null;

                var hasChecked = $ctrl.checkedDays.indexOf(DAYS_VALUES[i]) > -1;
                if (hasChecked) {
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == DAYS_VALUES[i]) {

                            tp = val.timePeriod;


                        }
                    });

                    // timePeriod = $ctrl.checkedDays[$ctrl.checkedDays.indexOf(DAYS_VALUES[i])].timePeriod;
                    // console.log('it has checked and time priod is:');
                    // console.log(timePeriod);
                }
                var weekDay = {
                    value: DAYS_VALUES[i],
                    name: DAYS_NAMES[i],
                    checked: hasChecked,
                    timePeriod: tp
                };
                retList.push(weekDay);

            }
            return retList;
        }

        function openEditTimeDialog(day) {

            $mdDialog.show({
                controller: EditTimeDialogController,
                templateUrl: 'app/components/partial-forms/weekly-work-days-v2/select-time-dialog-v2.template.html',
                locals: {dialogData: day},
                controllerAs: 'vm',
                targetEvent: day,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false
            })
                .then(function (answer) {
                    setCheckedDays();
                }, function () {
                    setCheckedDays();
                });

        };


        $ctrl.open = function (selectedDay) {

            //if the selected day has it own time period
            if (selectedDay.checked) {


                getDefaultTimePeriod(selectedDay, $ctrl.selectedWeeklyScheduleInfo.timePeriod);


                openEditTimeDialog(selectedDay);
                //show the time period dialog
                //DialogService.showDialog('app/components/partial-forms/weekly-work-days-v2/select-time-dialog-v2.template.html', $scope).then(function (e) {
                //    //if time has changed
                //
                //    if ($scope.startTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime ||
                //        $scope.endTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime
                //    ) {
                //
                //        var timePeriod = {startTime: $scope.startTime, endTime: $scope.endTime}
                //        selectedDay.timePeriod = timePeriod;
                //        angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                //            //  console.log(val.weekday);
                //
                //            if (val.weekday == selectedDay.value) {
                //
                //                val.timePeriod = selectedDay.timePeriod;
                //
                //            }
                //        });
                //        //angular.forEach( $ctrl.allWeekDays,function(val){
                //        //    //  console.log(val.weekday);
                //        //
                //        //    if(val.value==selectedDay.value) {
                //        //
                //        //        val.timePeriod=selectedDay.timePeriod;
                //        //
                //        //    }
                //        //});
                //
                //    }
                //
                //}, function (e) {//console.log('dialog result');
                //});
            }
        };

        function getDefaultTimePeriod(day, defaultTimePeriod) {
            if (!day.timePeriod) {
                if (defaultTimePeriod && defaultTimePeriod.startTime)
                    defaultStartTime = defaultTimePeriod.startTime;
                if (defaultTimePeriod && defaultTimePeriod.endTime)
                    defaultEndTime = defaultTimePeriod.endTime;
                day.timePeriod = {startTime: defaultStartTime, endTime: defaultEndTime, offtimes: []}
            }

        }

        $ctrl.ok = function () {
            $scope.showModal = false;
        };

        $ctrl.cancel = function () {
            $scope.showModal = false;
        };

    }

    var WeeklyWorkDaysV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/weekly-work-days-v2/partial-form.weekly-work-days-v2.html',
        controller: WeeklyWorkDaysV2Controller,
        bindings: {
            selectedWeeklyScheduleInfo: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfWeeklyWorkDaysV2', WeeklyWorkDaysV2)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    WeeklyWorkDaysV2Controller.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog'];
    var EditTimeDialogController = function ($scope, $mdDialog, dialogData) {

        var vm = this;
        vm.tp = dialogData.timePeriod;
        vm.day = dialogData;


        vm.hideDialog = function () {
            $mdDialog.hide();
        };

        vm.cancelDialog = function () {
            $mdDialog.cancel();
        };

    }
    EditTimeDialogController.$inject = ['$scope', '$mdDialog', 'dialogData'];


})();

